module.exports = __webpack_public_path__ + "img/Check.84b19d7a.svg";